// Module
var code = "<template> <require from=\"app/cm/components/case/care-team/care-team-grid\"></require> <care-team-grid case-id.bind=\"caseId\"></care-team-grid> </template> ";
// Exports
module.exports = code;